import { Component, OnInit } from '@angular/core';
import { WebPage } from '../../shared/web-page';
import { MessageService } from 'primeng/components/common/messageservice';
import { FormBuilder } from '@angular/forms';
import { FinanceiroService } from '../financeiro.service';
import { UnidadeService } from '../../shared/services/unidade.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfirmationService } from 'primeng/primeng';
import { Perfis } from '../../../models/perfis';

@Component({
  selector: 'sispac-gerenciar-valor-despesa-fornecedor',
  templateUrl: './gerenciar-valor-despesa-fornecedor.component.html',
  styleUrls: ['./gerenciar-valor-despesa-fornecedor.component.css']
})
export class GerenciarValorDespesaFornecedorComponent extends WebPage implements OnInit {

  despesas: any[];
  unidades: any[];
  tipoFornecedores: any[];

  constructor(messageService: MessageService,
    private fb: FormBuilder,
    private _financeiroService: FinanceiroService,
    private _unidadeService: UnidadeService,
    private router: Router,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService, ) {
    super(messageService);
  }

  ngOnInit() {
    const mensagem = localStorage.getItem('mensagem');
    if (mensagem != null && mensagem !== '') {
      this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: mensagem });
      localStorage.removeItem('mensagem');
    }

    this.listarValoresDespesas();
    this.listaUnidades();
    this.listaTipoFornecedores();
  }

  listarValoresDespesas() {
    this._financeiroService.getAllValorDespesas()
      .finally(() => this.isLoading = false)
      .subscribe(
        data => {
          this.despesas = data;
          // console.log(data);
        },
        error => {
          this.gerenciaErro(error);
        }
      );
  }

  listaUnidades() {
    this._unidadeService.getUnidades()
      .finally(() => this.isLoading = false)
      .subscribe(
        data => {
          this.unidades = data;
        },
        error => {
          this.gerenciaErro(error);
        }
      );
  }

  listaTipoFornecedores() {
    this._financeiroService.getAllTipoForcecedores()
      .finally(() => this.isLoading = false)
      .subscribe(
        data => {
          this.tipoFornecedores = data;
        },
        error => {
          this.gerenciaErro(error);
        }
      );
  }

  excluir(id) {
    const valorDespesa = this.despesas.find(x => x.idValorDespesa === id);
    if (valorDespesa !== null) {

      const objeto = {
        idValorDespesa: valorDespesa.idValorDespesa,
        idFase: valorDespesa.idFase,
        idUnidade: valorDespesa.idUnidade,
        idTipoFornecedor: valorDespesa.idTipoFornecedor,
        idEditalCredenciamento: valorDespesa.idEditalCredenciamento,
        idTipoDespesa: valorDespesa.idTipoDespesa,
        mes: valorDespesa.mes,
        valor: valorDespesa.valor,
        ativo: [false]
      };

      this.isLoading = true;
      this.confirmationService.confirm({
        message: 'Tem certeza que deseja excluir?',
        header: 'Confirmação',
        icon: 'fa fa-question-circle',
        accept: () => {
          this.isLoading = true;
          this._financeiroService.cadastrarEditarValorDespesa(objeto)
            .finally(() => this.isLoading = false)
            .subscribe(
              data => {
                this.listarValoresDespesas();
                this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Cadastro excluído com sucesso!' });
              },
              error => {
                this.gerenciaErro(error);
              }
            );
        },
        reject: () => {
          this.isLoading = false;
          this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Dados não enviados!' });
        }
      });
    }

  }

  editar(id) {
    this.isLoading = true;
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja editar este registro?”',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.isLoading = true;
        this.router.navigate(['/cadastar-despesa-fornecedor', id]);
      },
      reject: () => {
        this.isLoading = false;
        this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Dados não enviados!' });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/financeiro/gerenciar-valor-despesa-fornecedor/gerenciar-valor-despesa-fornecedor.component.ts